export type InfinitePaginationResult<T> = {
  data: T[];
  cursor: string | null;
  hasNextPage: boolean;
  totalItems: number;
};

export type PageInfo = {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string | null;
  endCursor: string | null;
};

export type PaginationResult<T> = {
  data: T[];
  pageInfo: PageInfo;
  totalCount: number;

  // Repositories can provide an explicit current page the table should
  // be set to when the returned content does not correspond to the first page
  currentPage?: number;
};

export const DEFAULT_PAGE = 0;

export const DEFAULT_PAGE_INFO = {
  hasNextPage: false,
  hasPreviousPage: false,
  startCursor: null,
  endCursor: null,
};

export const BLANK_PAGINATION_RESULT = {
  data: [],
  pageInfo: DEFAULT_PAGE_INFO,
  totalCount: 0,
};

/*
When we move through the pagination, we are moving around with cursors.
If we go a page up, we are moving "forwards", meaning that we take first elements
after a cursor.
Same, but reverse, is true for going page down and moving "backwards", meaning that
we take the last elements before a cursor.
 */

export type ForwardsCursor = {
  after: string | null;
  first: number;
};

export type BackwardsCursor = {
  before: string | null;
  last: number;
};

export type CursorInfo = BackwardsCursor | ForwardsCursor;
